<template>
  <div id="app">
    <popup-principal />
    <back-button />
    <router-view />
    <footer-legal />
  </div>
</template>

<script>
import PopupPrincipal from './components/PopupPrincipal.vue'
import BackButton from './components/BackButton.vue'
import FooterLegal from './components/FooterLegal.vue'

export default {
  name: 'App',
  components: {
    PopupPrincipal,
    BackButton,
    FooterLegal
  }
};
</script>

<style>
/* Global Dark Theme Enforcer */
body, html {
  background-color: #0f172a !important;
  color: #e2e8f0;
  min-height: 100vh;
}

#app {
  background: radial-gradient(circle at top left, #1e293b, #0f172a);
  min-height: 100vh;
  padding-bottom: 20px;
}

/* Glass Table Global Overrides - COMPREHENSIVE FIX */
.glass-table table, 
.glass-table-container table,
.table.glass-table {
  background-color: transparent !important;
  color: #fff !important;
}

.glass-table th, .glass-table-container th {
  color: #60a5fa !important;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1) !important;
}

.glass-table td, .glass-table-container td {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
  color: #e2e8f0 !important;
}

/* High Contrast Hover Effect - STRICT OVERRIDE */
.table.is-hoverable tbody tr:not(.is-selected):hover,
.glass-table tbody tr:hover,
.glass-table-container tbody tr:hover {
  background-color: rgba(59, 130, 246, 0.2) !important; /* Dark Blue Tint */
  color: #fff !important;
}

.table.is-hoverable tbody tr:not(.is-selected):hover td,
.glass-table tbody tr:hover td,
.glass-table-container tbody tr:hover td {
  color: #fff !important;
  border-bottom-color: rgba(255,255,255,0.1) !important;
}

/* Form Elements - Dark Mode */
.input, .textarea, .select select {
  background-color: rgba(30, 41, 59, 0.8) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  color: #f8fafc !important;
  box-shadow: none !important;
}

.label { color: #e2e8f0 !important; }

/* Mobile Table Cards Override - ULTRA AGGRESSIVE FIX */
@media screen and (max-width: 900px) {
  /* Force table background transparent */
  .table, .table.is-hoverable, .glass-table .table {
    background-color: transparent !important;
  }

  /* Target the card-rows specifically */
  .glass-table .table tbody tr,
  .glass-table-container .table tbody tr,
  .table.has-mobile-cards tbody tr {
    background-color: rgba(30, 41, 59, 0.95) !important; /* Dark Slate */
    border: 1px solid rgba(255, 255, 255, 0.15) !important;
    border-radius: 12px !important;
    display: block !important; /* Ensure card behavior */
    margin-bottom: 15px !important;
    padding: 15px !important;
    box-shadow: 0 4px 10px rgba(0,0,0,0.3) !important;
  }

  /* Ensure text is white */
  .glass-table .table tbody tr td,
  .table.has-mobile-cards tbody tr td {
    background-color: transparent !important;
    color: #e2e8f0 !important;
    border-bottom: 1px solid rgba(255,255,255,0.05) !important;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
  }

  /* Force Labels (headers in mobile) to be visible */
  .glass-table .table tbody tr td:before,
  .table.has-mobile-cards tbody tr td:before {
    color: #94a3b8 !important;
    font-weight: 700 !important;
    padding-right: 10px !important;
    text-transform: uppercase !important;
    font-size: 0.75rem !important;
  }

  /* Fix right-aligned buttons on mobile */
  .glass-table .table tbody tr td .buttons,
  .table.has-mobile-cards tbody tr td .buttons {
    justify-content: flex-end !important;
  }
}
</style>
